<template>
  <div>
    <v-layout wrap>
      <v-flex xs9>
        <h2>{{ $t('Receipt/ Tax invoice') }}</h2>
      </v-flex>
      <v-flex xs3 class="text-xs-right" style="align-self: center; margin-top: 12px">
        <toggle-button
          :value="invoice_status"
          :sync="true"
          :color="$vuetify.theme.success"
          @change="toggleStatus"
          :labels="{ checked: 'ON', unchecked: 'OFF' }"
          style="display: inline-block"
        />
      </v-flex>
    </v-layout>

    <template v-if="invoice_status">
      <v-layout wrap>
        <v-flex xs9>
          <label>{{ $t('Name of authorized signatory / name of payee') }}</label>
          <template v-if="!toggleEdit">
            <h3 class="mt-3 mb-3">{{ name || '-' }}</h3>
          </template>
          <div v-else class="form-control pa-1" :class="{ 'has-error': errors.has('name') }">
            <input
              :data-vv-as="$t('Name of authorized signatory / name of payee')"
              v-validate="'required'"
              v-model="name"
              name="name"
              class="form-control"
              type="text"
            />
            <span class="text-error" v-if="errors.has('name')">{{ errors.first('name') }}</span>
          </div>
        </v-flex>
        <v-flex xs3 class="text-xs-right" style="align-self: center; margin-top: 12px">
          <v-btn v-if="!toggleEdit" outline small fab color="primary" @click="toggleEdit = true">
            <v-icon>edit</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
      <label>{{ $t('Signature') }}</label>
      <v-layout>
        <v-flex class="pa-1" style="max-width:25%">
          <template v-if="!toggleEdit">
            <div class="primary--text" v-if="!photo">-</div>
            <v-img :src="photo" :aspect-ratio="1" v-else></v-img>
          </template>
          <uploadfile v-else v-model="photo" :height="250" @onUploaded="onUploaded"></uploadfile>
        </v-flex>
        <v-flex>
          <v-btn v-if="toggleEdit" fab small @click="photo = ''" depressed
            ><v-icon>delete</v-icon></v-btn
          >
        </v-flex>
      </v-layout>
      <div class="text-xs-center" v-if="toggleEdit">
        <v-btn outline color="grey" @click="cancle">{{ $t('cancel') }}</v-btn>
        <v-btn depressed color="primary" @click="putPageReceiptConfig()">{{ $t('Save') }}</v-btn>
      </div>
    </template>
    <v-dialog v-model="showModal" width="800">
      <v-card v-if="showModal">
        <v-card-text>
          <div style="text-align: right">
            <v-btn @click="cancelEditAddress" icon>
              <v-icon>close</v-icon>
            </v-btn>
          </div>
          <label for="pageAddress">{{ $t('Shop Address') }}</label>

          <shipping-address></shipping-address>
          <div class=" text-xs-center mt-3">
            <v-btn outline @click="cancelEditAddress()">{{ $t('cancel') }}</v-btn>
            <v-btn
              @click="saveAddress()"
              :loading="$store.state.loading"
              depressed
              color="primary"
              :disabled="!addresses || addresses.length == 0"
            >
              {{ $t('Save') }}
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import api from '@/api'
import { ToggleButton } from 'vue-js-toggle-button'

import uploadfile from '@/components/elements/uploadfile'
import ShippingAddress from '@/components/view/setting/ecommerce/ShippingAddress'

export default {
  components: {
    uploadfile,
    ToggleButton,
    ShippingAddress
  },
  data() {
    return {
      toggleEdit: false,
      invoice_status: null,
      photo: null,
      name: null,
      dataForCancle: null,
      showModal: false
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      addresses: 'getShippingAddress',
      currentLang: 'currentLang'
    })
  },
  mounted() {
    this.getPageReceiptConfig()
  },
  methods: {
    cancle() {
      var data = JSON.parse(this.dataForCancle)
      this.photo = data.img_url
      this.name = data.name
      this.toggleEdit = false
    },
    onUploaded: function(image) {
      this.photo = image
    },

    getPageReceiptConfig() {
      // this.$store.dispatch('loading')
      var data = { pageid: this.selectedBot.pageid }
      return new Promise((resolve, reject) => {
        api.getPageReceiptConfig(data, (error, response) => {
          if (error) {
            // this.$store.dispatch('loading')
            reject(error)
          }
          if (response) {
            if (response.data.success) {
              this.dataForCancle = JSON.stringify(response.data.result.receipt_json[0])
              this.invoice_status = response.data.result.receipt_status
              this.photo = response.data.result.receipt_json[0].img_url
              this.name = response.data.result.receipt_json[0].name
            }
            // this.$store.dispatch('loading')
            resolve(response)
          }
        })
      })
    },

    async toggleStatus({ value }) {
      if ((!this.addresses || (this.addresses && !this.addresses.length)) && value) {
        const result = await this.$swal.fire({
          title: this.$t('Please enter shop address'),
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: this.$t('Confirm'),
          cancelButtonText: this.$t('cancel'),
          reverseButtons: true
        })
        if (result.value) {
          this.showModal = true
        }
      } else {
        this.invoice_status = !this.invoice_status
        this.putPageReceiptConfig()
      }
    },
    loadPageProfile() {},
    async saveAddress() {
      this.$store.dispatch('loading')

      this.showModal = false
      await this.$store.dispatch('updateBotDetail')
      if (this.addresses) {
        this.invoice_status = !this.invoice_status
        this.putPageReceiptConfig()
      }
      this.$store.dispatch('loading')
    },
    cancelEditAddress() {
      this.showModal = false
    },

    putPageReceiptConfig() {
      this.$store.dispatch('loading')
      var data = {
        body: {
          receipt_status: this.invoice_status,
          receipt_json: [
            {
              name: this.name,
              img_url: this.photo
            }
          ]
        },
        params: { pageid: this.selectedBot.pageid }
      }
      return new Promise((resolve, reject) => {
        api.putPageReceiptConfig(data, (error, response) => {
          if (error) {
            this.$store.dispatch('loading')
            reject(error)
          }
          if (response) {
            if (response.data.success) {
              this.dataForCancle = JSON.stringify(response.data.result.receipt_json[0])
              this.invoice_status = response.data.result.receipt_status
              this.photo = response.data.result.receipt_json[0].img_url
              this.name = response.data.result.receipt_json[0].name
              this.toggleEdit = false
              this.$store.dispatch('updateBotDetail')
            }
            this.$store.dispatch('loading')
            resolve(response)
          }
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/TaxInvoice.vue